module.exports = __webpack_public_path__ + "media/application/placeholder-9f52f18e.png";